import { PAGES } from "@consts";
import ClickOutside from "vue-click-outside";

export default {
	name: "TheNewHeader",
	data() {
		return {
			brandsOpen: false,
			currentHeaderScroll: 0,
		};
	},
	directives: {
		ClickOutside,
	},
	computed: {
		showBorder() {
			return !this.isPersistentSearch;
		},
		isPersistentSearch() {
			return this.$store.getters["navigation/isPersistentSearch"];
		},
		headerTopIndent() {
			// Since we're talking about pushing the header upwards, 'highestScroll' is an increasingly-negative number as the user scrolls downwards, and 'lowestScroll' is an increasingly-positive number as the user scrolls upwards.
			const newScrollY = this.scrollY;
			let newHeaderScroll = this.$store.state.window.topAdHeight;
			if (newScrollY > 0) {
				const delta = this.currentWindowScroll - newScrollY;
				newHeaderScroll = this.currentHeaderScroll + delta;

				if (newHeaderScroll < this.highestScroll) {
					newHeaderScroll = this.highestScroll;
				} else if (newHeaderScroll > this.lowestScroll) {
					newHeaderScroll = this.lowestScroll;
				}
			}
			if (this.mobileMenuIsOpen) {
				newHeaderScroll = this.$store.state.window.topAdHeight;
			}
			this.currentWindowScroll = newScrollY;
			this.currentHeaderScroll = newHeaderScroll;

			this.$store.commit(
				"window/setVisibleHeaderHeight",
				this.$store.getters["window/headerHeight"] +
					newHeaderScroll -
					this.$store.state.window.topAdHeight
			);

			return {
				top: `${this.currentHeaderScroll}px`,
			};
		},
		highestScroll() {
			return this.isSmallDevice
				? -this.$store.getters["window/headerHeight"]
				: this.$store.state.window.topAdHeight -
						this.$store.getters["window/headerHeight"];
		},
		lowestScroll() {
			return this.isSmallDevice
				? 0
				: this.$store.state.window.topAdHeight;
		},
		scrollY() {
			return this.$store.state.window.scrollY;
		},
		isAppPage() {
			return [PAGES.GET_THE_APP, PAGES.APP_ABOUT].includes(
				this.$route.name
			);
		},
		showGetTheAppButton() {
			if (this.isSmallDevice) {
				return true;
			}

			if (this.$store.getters["navigation/isCrosswordsPage"]) {
				return false;
			}

			return true;
		},
		mobileMenuIsOpen() {
			return this.$store.state.navigation.mobileMenuIsOpen;
		},
		desktopSubMenuIsOpen() {
			return this.$store.state.navigation.desktopSubMenuIsOpen;
		},
		hotjarMobileSurveyOpened() {
			return this.$store.state.navigation.hotjarMobileSurveyOpened;
		},
	},
	methods: {
		onClickOutside(e) {
			if (
				e.srcElement?.parentElement?.classList?.contains?.(
					"brands-button"
				)
			) {
				return;
			}
			if (this.brandsOpen) {
				this.toggleBrandsMenu();
			}
		},
		toggleBrandsMenu() {
			this.brandsOpen = !this.brandsOpen;
		},
		toggleBodyScroll(value) {
			if (value) {
				document.body.classList.add("overflow-y-hidden");
			} else {
				document.body.classList.remove("overflow-y-hidden");
			}
		},
		async onFeedbackClick() {
			if (
				typeof window !== "undefined" &&
				typeof window.hj === "function"
			) {
				this.$store.commit(
					"navigation/setHotjarMobileSurveyOpened",
					true
				);
				this.$store.commit("navigation/toggleMobileMenu", false);

				await this.$nextTick();

				window.hj("event", "open_survey_event");
			} else {
				console.warn("Hotjar is not loaded yet.");
			}
		},
	},
	watch: {
		desktopSubMenuIsOpen(value) {
			this.toggleBodyScroll(value);
		},
		mobileMenuIsOpen(value) {
			this.toggleBodyScroll(value);
		},
	},
};
